import axios from './axiosConfig';
import { CookieNames, getCookie } from '../helpers/cookie.helper';

export const getAllPaymentsList = async (params = {
    PageIndex: 1,
    PageSize: 10,
    SearchText: '',
    FromDate: '',
    ToDate: ''
}) => {
    try {
        const response = await axios.get(`/api/Payment/GetAllPaymentsList`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}


export const getAllPaymentsReport = async (params = {
    PageIndex: 1,
    PageSize: 10,
    SearchText: '',
    FromDate: '',
    ToDate: ''
}) => {
    try {
        const response = await axios.get(`/api/Payment/GetAllPaymentsReport`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            },
            responseType: 'arraybuffer'  // Ensure the response is treated as binary data
        });

        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const downloadPaymentAttachment = async (paymentId) => {
    try {
        const response = await axios.get(`/api/Payment/DownloadPaymentAttachment`, {
            params: {
                PaymentNo: paymentId,
                SessionId: getCookie(CookieNames.SESSION_ID),
            },
            responseType: 'arraybuffer'  // Ensure the response is treated as binary data
        });

        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const getPaymentsListByCompanyId = async (params = {
    CompanyId: '',
    PageIndex: 1,
    PageSize: 10,
    SearchText: '',
    FromDate: '',
    ToDate: ''
}) => {
    try {
        const response = await axios.get(`/api/Payment/GetPaymentsListByCompanyId`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getPaymentsReport = async (params = {
    PageIndex: 1,
    PageSize: 10,
    SearchText: '',
    FromDate: '',
    ToDate: ''
}) => {
    try {
        const response = await axios.get(`/api/Payment/GetPaymentsReport`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            },
            responseType: 'arraybuffer'  // Ensure the response is treated as binary data
        });

        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const markPaymentAsPaid = async (formData) => {
    try {
        const response = await axios.post(
            `/api/Payment/MarkPaymentAsPaid`,
            formData,
            {
                params: { SessionId: getCookie(CookieNames.SESSION_ID) },
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}